/**
 * @desc 开启财务审批流程
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<defs.activiti.ActivitiProcessInstanceDto>;
export function request(
  body: defs.activiti.FinanceApprovalStartRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/financeApprovalFacade/startProcessInstance`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
